import { useState, useEffect } from "react";
import "../styles/Erodebookfair.css";
import Loader from "./Loader.jsx";

const Erodebookfair = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [images, setImages] = useState([]);
  const [zoomLevel, setZoomLevel] = useState(1);
  const [scrollPosition, setScrollPosition] = useState({ top: 0, left: 0 });

  const zoomIn = (e) => {
    e.stopPropagation();
    const newZoom = Math.min(zoomLevel + 0.25, 3);
    setZoomLevel(newZoom);

    // Reset scroll position when zooming in
    const container = document.querySelector(".fullscreen-image-container");
    if (container) {
      container.scrollTop = 0;
      container.scrollLeft = 0;
    }
  };

  const zoomOut = (e) => {
    e.stopPropagation();
    setZoomLevel(Math.max(zoomLevel - 0.25, 1));
  };

  const handleScroll = (e) => {
    setScrollPosition({
      top: e.target.scrollTop,
      left: e.target.scrollLeft
    });
  };

  const openImage = (img) => {
    setSelectedImage(img);
  };

  const closeImage = () => {
    setSelectedImage(null);
  };
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch("/data/erodebookfair.json");
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const data = await response.json();
        console.log(data);

        setImages(data.erodebookfair);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) return <Loader />;
  if (error) return <div className="error-message">Error: {error}</div>;
  return (
    <div className="containerfair">
      <div className="content">
        <h2 className="heading">ஈரோடு புத்தகத் திருவிழா</h2>
        <p className="paragraph">
          ஈரோட்டில், ஒவ்வொரு ஆண்டும் நடைபெறும் புத்தகக் கண்காட்சியாகும். மக்கள்
          நீண்டநாள் பேரவை என்ற சமூக அமைப்பால் இந்த திருவிழா நடத்தப்படுகிறது.
          <span style={{ fontWeight: "bolder" }}>
            {" "}
            தமிழ்நாட்டின் இரண்டாவது மிகப் பெரிய புத்தகத் திருவிழாவாகும்.
          </span>
        </p>
        <p className="paragraph">
          இந்த விழாவில்{" "}
          <span style={{ fontWeight: "bolder" }}> 12 நாட்கள் </span> நடைபெறும்.
          பல்வேறு{" "}
          <span style={{ fontWeight: "bolder" }}>
            {" "}
            புத்தக வெளியீட்டாளர்கள், விரிவான புத்தகக் காட்சிகள், மேடைச்
            சொற்பொழிவுகள், ஆர்வமுள்ள வாசகர்களுக்கு
          </span>{" "}
          புத்தக வெளியீட்டாளர்களை நேரில் சந்திக்கும் வாய்ப்பு போன்றவை
          இடம்பெறுகின்றன. பள்ளி மற்றும் கல்லூரி மாணவர்களும் இதில் கலந்து
          கொள்கின்றனர்.
        </p>
      </div>
      <div className="imageRow">
        <img
          src="https://makalukkaga.mpeoplesnet.com/bookfair/001.jpg"
          alt="Erode Book Fair 1"
          className="image"
        />
        <img
          src="https://makalukkaga.mpeoplesnet.com/bookfair/002.jpg"
          alt="Erode Book Fair 2"
          className="image"
        />
      </div>
      <div className="gallery-container">
        <div className="image-grid1">
          {images.map((img, index) => (
            <div
              key={index}
              className="image-item"
              onClick={() => openImage(img)}
            >
              <img src={img} alt={`Gallery item ${index + 1}`} loading="lazy" />
            </div>
          ))}
        </div>

        {selectedImage && (
          <div className="fullscreen-overlay" onClick={closeImage}>
            <div
              className="fullscreen-image-container"
              onClick={(e) => e.stopPropagation()}
              onScroll={handleScroll}
              style={{ overflow: zoomLevel > 1 ? "scroll" : "hidden" }}
            >
              <img
                src={selectedImage}
                alt="Full screen"
                style={{
                  transform: `scale(${zoomLevel})`,
                  transformOrigin: "top left",
                  width: "100%",
                  height: "auto"
                }}
              />
            </div>
            <button className="close-button" onClick={closeImage}>
              ×
            </button>
            <div className="zoom-controls">
              <button className="zoom-button" onClick={zoomIn}>
                +
              </button>
              <button className="zoom-button" onClick={zoomOut}>
                -
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Erodebookfair;
